import { useState } from "react";

export default function Tooltip({ children, tooltip, position = "bottom" }) {
  const [visible, setVisible] = useState(false);

  const getPositionClasses = () => {
    switch (position) {
      case "right":
        return "left-full top-1/2 -translate-y-1/2 ml-2";
      case "left":
        return "right-full top-1/2 -translate-y-1/2 mr-2";
      case "top":
        return "bottom-full left-1/2 -translate-x-1/2 mb-2";
      case "bottom":
      default:
        return "top-full left-1/2 -translate-x-1/2 mt-2";
    }
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && (
        <div className={`absolute ${getPositionClasses()} px-3 py-1 rounded-lg bg-[#0F172A] text-white border border-gray-700 text-xs shadow-xl whitespace-nowrap z-[100]`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}
